import PageBackTitle from "../../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
// import "./User.css";
import { Link, useNavigate } from "react-router-dom";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { MdAttachFile } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import useClickOutside from "../../useClickOutside";
import API_URL from "../../../src/Config";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Pagination from "../../Component/Pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // for styling
import CylinderPopup from "../Popup/CylinderPopup";
import TextField from "@mui/material/TextField"; // if you're using MUI

function GasDetectorCallibaration({ isSidebarExpanded, departmentID }) {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState(null);
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isCylinderPopupOpen, setIsCylinderPopupOpen] = useState(false);
  const [selectedDetectorId, setSelectedDetectorId] = useState(null);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);
  const [calibrations, setCalibrations] = useState([]);

  const statusOptions = [
    { value: "all", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Overdue", label: "Overdue" },
    { value: "cancelled", label: "Cancelled" },
    { value: "completed", label: "Completed" },
  ];

  const filterOptions = [
    { label: "All", value: "all" },
    { label: "Today", value: "today" },
    { label: "Tomorrow", value: "tomorrow" },
    { label: "Next 7 Days", value: "next7days" },
    { label: "Current Week", value: "current_week" },
    { label: "Past Week", value: "past_week" },
    { label: "Current Month", value: "current_month" },
    { label: "Custom Date", value: "custom_date" },
  ];

  const [selectedScheduleStatus, setSelectedScheduleStatus] = useState("all");

  const Navigate = useNavigate();
  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  const fetchStatusData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(
        `${API_URL}/api/reports/gas_detector/kpis`,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      const data = response.data;

      console.log("data", data);

      if (data) {
        setCalibrations(data || []);
        // setTotalSchedules(data.total_schedules || null);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching scheduler data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatusData();
  }, []);

  const handleScheduleStatusChange = (event) => {
    const newStatus = event.target.value;
    setSelectedScheduleStatus(newStatus);
    fetchData(newStatus); // Fetch with selected status
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setSelectedFilter(value);

    if (value !== "custom_date") {
      fetchData(value, page, itemsPerPage); // You must already have page & itemsPerPage state
    }
  };

  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setSelectedStartDate(start);
    setSelectedEndDate(end);

    if (start && end) {
      fetchData(start, end); // custom function you'll define below
    }
  };

  const handleDeletePopup = () => {
    setIsDeletePopup(!isDeletePopup);
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const handleSort = (column) => {
    const order =
      sortColumn === column && sortOrder[column] === "asc" ? "desc" : "asc";

    setSortColumn(column);
    setSortOrder((prevOrder) => ({
      ...prevOrder,
      [column]: order,
    }));

    setIsSortPopup(false);

    const sortedBreakdown = [...departments].sort((a, b) => {
      const aValue = a[column]?.toString().toLowerCase() || "";
      const bValue = b[column]?.toString().toLowerCase() || "";

      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });

    setDepartments(sortedBreakdown);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  const fetchData = async (
    status = "all",
    currentPage,
    itemsPerPage,
    filter = "all",
    startDate = null,
    endDate = null,
    searchQuery = ""
  ) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const params = {
        status: status,
        page: currentPage,
        per_page: itemsPerPage,
        filter_option: filter,
        query: searchQuery,
      };

      // Only include start & end date for custom_date filter
      if (filter === "custom_date" && startDate && endDate) {
        params.start_date = startDate;
        params.end_date = endDate;
      }

      const response = await axios.get(
        `${API_URL}/api/get_gas_detector_schedules`,
        {
          headers: {
            Authorization: authKey,
          },
          params,
        }
      );

      const gasDetectors = response.data.schedules || [];
      const totalItems = response.data.total || 0;

      setDepartments(gasDetectors);
      setTotalItems(totalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(
      "all",
      page,
      itemsPerPage,
      selectedFilter,
      selectedStartDate,
      selectedEndDate,
      searchInput // Pass search here
    );
  }, [
    page,
    itemsPerPage,
    selectedFilter,
    selectedStartDate,
    selectedEndDate,
    searchInput,
  ]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedRows(
      newSelectAll ? departments.map((department) => department.ID) : []
    );
    setChecked(newSelectAll);
  };

  const handleSelectRow = (departmentID) => {
    const updatedSelectedRows = selectedRows.includes(departmentID)
      ? selectedRows.filter((id) => id !== departmentID)
      : [...selectedRows, departmentID];

    setSelectedRows(updatedSelectedRows);
    setSelectAll(updatedSelectedRows.length === departments.length);
    setChecked(updatedSelectedRows.length > 0);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const openCylinderPopup = (detectorId, scheduleId) => {
    setSelectedDetectorId(detectorId);
    setSelectedScheduleId(scheduleId);
    setIsCylinderPopupOpen(true);
  };

  const closeCylinderPopup = () => {
    setIsCylinderPopupOpen(false); // Hide the popup
    setSelectedDetectorId(null); // Reset the ID
  };

  const handleArchivedDepartment = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/archive_department`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
        body: JSON.stringify({ ids: selectedRows }),
      });

      if (response.ok) {
        showSnackbar("Data archived successfully");
        const updatedDepartments = departments.filter(
          (department) => !selectedRows.includes(department.ID)
        );
        setDepartments(updatedDepartments);
        setSelectedRows([]);
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to delete departments");
      }
    } catch (error) {
      console.error("An error occurred while deleting departments:", error);
    }
  };

  const handleCloseButtonClick = () => {
    setChecked(false);
    setSelectedRows([]);
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  const handleRefresh = () => {
    fetchData();
    setSearchInput("");
  };
  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };
  const handleArchiveDeparment = () => {
    Navigate("/archive-department");
  };

  const handleStatusChange = () => {
    fetchData(
      "all",
      page,
      itemsPerPage,
      selectedFilter,
      selectedStartDate,
      selectedEndDate
    );
  };

  const closePopup = () => {
    setIsCylinderPopupOpen(false);
  };

  const handleIconClick = (index) => {
    // setIsPopupOpen(inquiryID);
    setIsPopupOpen(index === isPopupOpen ? null : index);
    setSelectedRowIndex(false);
  };
  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  useClickOutside([containerRef, buttonRef], handleCloseAttachment, 200); // 200ms delay
  useClickOutside([popupRef, buttonRef], handleCloseAttachment, 300);

  const handlecalibrationLogs = (id) => {
    Navigate(`/calibration-logs/${id}`);
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          {isChecked ? (
            <div className="action-header">
              <div className="action-header-content">
                <div className="action-header-content-leftside">
                  <div className="action-button">
                    <button className="delete" onClick={handleDeletePopup}>
                      Move to archive
                    </button>
                    {isDeletePopup && (
                      <div className="confirm-delete-popup">
                        <div className="confirm-delete-popup-content">
                          <div className="confirm-model">
                            <div className="confirm-model-content">
                              <div className="confirm-model-content-body">
                                <p>Are you sure want to move archive?</p>
                              </div>
                              <div className="confirm-model-content-footer">
                                <button
                                  className="confirm-delete-button"
                                  onClick={handleArchivedDepartment}
                                >
                                  Yes
                                </button>
                                <button
                                  className="confirm-cancel-button"
                                  onClick={handleCancel}
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="action-header-content-rightside">
                  <button
                    className="action-header-close-button"
                    onClick={handleCloseButtonClick}
                  >
                    <IoCloseOutline className="action-header-close-icon" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="data-list-header">
              <div className="data-list-header-content">
                <PageBackTitle>Gas Detector Calibration</PageBackTitle>
                <div className="data-list-heading-content-right-side">
                  <div className="project-dropdown-schedules">
                    <FormControl fullWidth>
                      <InputLabel id="filter-select-label">Status</InputLabel>
                      <Select
                        labelId="filter-select-label"
                        id="filter-select"
                        value={selectedScheduleStatus}
                        onChange={handleScheduleStatusChange}
                        label="Status"
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="project-dropdown-schedules">
                    <FormControl fullWidth>
                      <InputLabel id="filter-select-label">Filter</InputLabel>
                      <Select
                        labelId="filter-select-label"
                        id="filter-select"
                        value={selectedFilter}
                        onChange={handleFilterChange}
                        label="Filter"
                      >
                        {filterOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {selectedFilter === "custom_date" && (
                    <div className="input-group-datepickers">
                      <DatePicker
                        placeholderText="Select Date Range"
                        className="dates"
                        startDate={selectedStartDate}
                        endDate={selectedEndDate}
                        selectsRange={true}
                        isClearable
                        dateFormat="yyyy-MM-dd"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onChange={handleDateRangeChange}
                        renderInput={(startProps, endProps) => (
                          <>
                            <TextField {...startProps} variant="standard" />
                            <TextField {...endProps} variant="standard" />
                          </>
                        )}
                        startText="Start Date"
                        endText="End Date"
                      />
                    </div>
                  )}
                  <div className="search-bar-container">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchInput}
                      onChange={handleSearchInputChange}
                      className="search-bar"
                    />
                    <IoSearchOutline className="search-bar-icon" />
                  </div>

                  <Tooltip title="Refresh List" arrow>
                    <button className="refresh-button" onClick={handleRefresh}>
                      <TbRefresh className="refresh-icon" />
                    </button>
                  </Tooltip>
                  <button
                    className="sort-button"
                    onClick={handleSortpopup}
                    ref={buttonRef}
                  >
                    <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                  </button>
                  {isSortPopup && (
                    <div className="sort-popup-container" ref={containerRef}>
                      <div className="sort-popup-content">
                        <div className="sort-by">
                          SORT BY{" "}
                          {sortOrder[sortColumn] === "asc"
                            ? "(Ascending)"
                            : "(Descending)"}
                        </div>
                        <div className="sort-by-button">
                          <button onClick={() => handleSort("DepartmentName")}>
                            DepartmentName{" "}
                            {sortOrder.DepartmentName === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                        </div>
                        <button
                          className="delete-item"
                          onClick={handleArchiveDeparment}
                        >
                          Archived Departments
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="entity-dashboard">
            <div className="entity-dashboard-contant">
              <div className="entity-dashboard-contant-item">
                <div className="entity-icon"></div>
                <div className="entity-text-left">
                  <div className="entity-text">
                    <div className="entity-text-title">Total Calibrations</div>
                    <div
                      className="entity-text-title-total"
                      onClick={() => fetchData("all", 1, 50)}
                    >
                      {calibrations?.TotalCalibrations}
                    </div>
                  </div>
                </div>
              </div>
              <div className="entity-text-right">
                <div className="entity-text">
                  <div className="entity-text-title">Due Today</div>
                  <div
                    className="entity-text-title-total "
                    // onClick={() => fetchSchedulesByDateType("today")}
                  >
                    {calibrations?.DueToday || "0"}
                  </div>
                </div>{" "}
                <div className="entity-text">
                  <div className="entity-text-title">Due Tomorrow</div>
                  <div className="entity-text-title-total">
                    {calibrations?.DueTomorrow || "0"}
                  </div>
                </div>
                <div className="entity-text">
                  <div className="entity-text-title">Overdue</div>
                  <div className="entity-text-title-total">
                    {calibrations?.OverdueCount || "0"}
                  </div>
                </div>
                <div className="entity-text">
                  <div className="entity-text-title">Active</div>
                  <div className="entity-text-title-total">
                    {calibrations?.ActiveCount || "0"}
                  </div>
                </div>
                <div className="entity-text">
                  <div className="entity-text-title">Completed</div>
                  <div className="entity-text-title-total">
                    {calibrations?.CompletedCount || "0"}
                  </div>
                </div>{" "}
                <div className="entity-text">
                  <div className="entity-text-title">Cancelled</div>
                  <div className="entity-text-title-total">
                    {calibrations?.CancelledCount || "0"}
                  </div>
                </div>
                <div className="entity-text">
                  <div className="entity-text-title">Failed</div>
                  <div className="entity-text-title-total">
                    {calibrations?.FailedCount || "0"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : departments.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th className="center-alignment">SR. No.</th>
                        <th>TAG NO</th>

                        <th>CALIBRATION FREQUENCY</th>
                        <th>STATUS</th>
                        <th>CALIBRATION DUE DATE</th>
                        <th>GENERATED AT</th>
                        <th>ATTACHMENTS</th>
                        <th className="center-alignment">ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {departments.map((department, index) => (
                        <tr key={department.ID} className="hoverable-row">
                          <td className="center-alignment">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(department.ID)}
                              onChange={() => handleSelectRow(department.ID)}
                            />
                          </td>
                          <td className="center-alignment">{index + 1}</td>
                          <td className="tag-numberss">
                            {department.tag_no || "NA"}
                          </td>

                          <td>{department.frequency || "NA"}DAYS</td>
                          <td
                            style={{
                              color:
                                department.status === "Overdue"
                                  ? "red"
                                  : department.status === "Pending"
                                  ? "orange"
                                  : department.status === "completed"
                                  ? "green"
                                  : department.status === "InProgress"
                                  ? "blue"
                                  : department.status === "cancelled"
                                  ? "gray"
                                  : department.status === "failed"
                                  ? "darkred"
                                  : "inherit",
                              fontWeight: "300",
                            }}
                          >
                            {department.status}
                          </td>
                          <td>{formatDate(department.calibration_due_date)}</td>

                          <td>{department.generated_at || "NA"}</td>
                          <td className="center-alignment">
                            <span
                              className="inquiry-file-btns"
                              onClick={(event) => handleIconClick(index, event)}
                            >
                              <MdAttachFile className="inquiry-file-icon" />
                            </span>
                            {isPopupOpen === index && (
                              <div
                                className="inquiry-attach-popup Whole-popup"
                                style={{ left: "56%" }}
                                ref={popupRef}
                              >
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  <div
                                    className="attach-popup-contant-body"
                                    key={index}
                                  >
                                    {department.attachments &&
                                    department.attachments.length > 0 ? (
                                      <div className="attach-popup-content-body">
                                        {department.attachments.map(
                                          (attachment, attachmentIndex) => (
                                            <div
                                              className="inquiry-attach-file-container"
                                              key={attachmentIndex}
                                            >
                                              <div className="inquiry-attacth-file-model">
                                                <div className="attach-file-show">
                                                  <div className="text-attachment">
                                                    {attachment.filename
                                                      .length > 20
                                                      ? `${attachment.filename.substring(
                                                          0,
                                                          15
                                                        )}...`
                                                      : attachment.filename}
                                                  </div>
                                                  <div className="text-attachment-file">
                                                    File Size:{" "}
                                                    {attachment.file_size ||
                                                      "NA"}{" "}
                                                    KB
                                                  </div>
                                                </div>

                                                <div className="file-footer">
                                                  {/* ✅ Download API */}
                                                  <a
                                                    href={`${API_URL}/api/gas_detector_calibration/download_calibration_attachment/${attachment.file_id}`}
                                                    className="file-download-attachment file-txt"
                                                    download
                                                  >
                                                    Download
                                                  </a>

                                                  {/* ✅ View API */}
                                                  <a
                                                    href={`${API_URL}/api/gas_detector_calibration/view_calibration_attachment/${attachment.file_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="file-download-attachment file-txt"
                                                  >
                                                    View
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    ) : (
                                      <div className="no-attachments">
                                        No attachments found
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </td>
                          <td>
                            <div className="buttons">
                              <button
                                className="button-bgsss"
                                onClick={() =>
                                  openCylinderPopup(
                                    department.detector_id,
                                    department.id
                                  )
                                }
                              >
                                Change Status
                              </button>
                              <button
                                className="button-bgsss"
                                onClick={() =>
                                  handlecalibrationLogs(department.id)
                                }
                              >
                                Calibration Logs
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">
                      No Gas Detector Found
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {isCylinderPopupOpen && (
            <CylinderPopup
              closePopup={closePopup}
              handleNewDepartment={handleStatusChange} // 👈 passed here
              detectorId={selectedDetectorId}
              scheduleId={selectedScheduleId}
            />
          )}

          <Pagination
            showPerPage={itemsPerPage}
            total={totalItems}
            onPaginationChange={handlePaginationChange}
          />
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default GasDetectorCallibaration;
